export default "__VITE_PUBLIC_ASSET__13dc2097__"